const mixinCharts = {
  data () {
    return {
      paleta_color: ['#1ABC9C', '#0089C7', '#DE6C47', '#FFB311', '#F9F966', '#d13814', '#9b59b6', '#f17cb0', '#84754e', '#003666', '#EACA69', '#00B4FF', '#F97566']
    }
  },

  methods: {
    spline (data_) {
      let chartOptions = {
        chart: {
          zoomType: 'xy',
          type : 'spline'
        },
        title: {
          text: (data_.title) ? data_.title : 'Titulo del Gráfico', //'Pron\u00F3stico Clim\u00E1tico',
          x: -20 //center
        },
        subtitle: {
            text: (data_.subtitle) ? data_.subtitle : 'Sub Titulo del Gráfico', //'ZONA: ',
            x: -20
        },
        xAxis: {
          categories: data_.categories,
        },
        yAxis: data_.yAxis ? data_.yAxis : {
          title: {
            text: data_.yAxisT,
            style: {
              color: '#1ABC9C'
            }
          },
          tickAmount: 5
        },
        tooltip: {
          crosshairs: true,
          shared: true,
        },
        plotOptions: {
          spline: {
            //stacking: 'percent',//'normal',
            dataLabels: {
              enabled: true,
              //format: '{point.y:.1f}',
              color: 'black',
              /* style: {
                  textShadow: '0 0 3px black, 0 0 3px black'
              }*/
            }
          }
        },
        series: data_.series
      }

      return chartOptions
    },

    columns (data_, decimal_, percent_ = false) {
      let mThis = this
      decimal_ = (decimal_ == null) ? data_.decimal : decimal_;
      let chartOptions = {
        colors: this.paleta_color,
        chart: {
          type: 'column',
          zoomType: 'x',
        },
        title: {
          text: data_.Titulo
        },
        subtitle: {
          text: data_.STitulo
        },
        xAxis: {
          categories: data_.xAxis,
          crosshair: true,
          labels: {
            //rotation: -90,
            style: {
              color: '#6e6e70'//,
              //fontWeight: 'bold'
            },
          }
        },
        yAxis: data_.yAxis ? data_.yAxis : {
          min: 0,
          title: {
            text: data_.yAxisT,
            align: 'high'
          },
          labels: {
            style: {
              color: '#6e6e70'//,
              //fontWeight: 'bold'
            }
          }
        },
        // tooltip: {

          // headerFormat: '<span style="font-size:9px">{point.key}</span><table>',
          // pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          // '<td style="padding:0"><b>{point.y:.0f}</b></td></tr>',
          // footerFormat: '</table>',
          // shared: true,
          // useHTML: true
        // },
        tooltip: {
          formatter: function () {
            var value = (mThis.formatMoney(this.y, decimal_));
            return '<span style="font-size: 10px">' + this.key +
            '</span><br/>' +
            '<span style="color:' + this.series.color + '">\u25CF</span> '
            + this.series.name + ': <b>' + value + ( (percent_) ? " %" : "" ) + '</b><br/>';
          },
          useHTML: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.05,
            borderWidth: 0,
            // dataLabels: {
              // enabled: true,
              // color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'gray'
            // }
            dataLabels: {
              enabled: true,
              color: 'gray',
              formatter: function () {
                //return (mThis.formatMoney(this.y, decimal_));
                return (this.y!=0)? (mThis.formatMoney(this.y, decimal_)) + ( (percent_) ? " %" : "" ) : null;
              }
            }
          },
          series: {
            shadow: true
          }
        },
        series : data_.values

      }

      return chartOptions
    },

    pieChart (data_, decimal_, percent_ = false){
      decimal_ = (decimal_ == null) ? data_.decimal : decimal_;

      let chartOptions = {
        colors: this.paleta_color,
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,//null,
          plotShadow: false,
          type: 'pie',
        },
        title: {
          text: data_.Titulo
        },
        subtitle: {
          text: data_.STitulo,
          x: -20
        },
        // tooltip: {
          // formatter: function () {
            // var value = this.y.formatMoney(decimal, ',', '.');
            // return '<span style="font-size: 10px">' + this.key +
            // '</span><br/>' +
            // '<span style="color:' + this.series.color + '">\u25CF</span> '
            // + this.series.name + ': <b>' + value  + '</b><br/>';
          // },
          // useHTML: true
        // },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y:.f}</b><br/><b>{point.percentage:.2f} %</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: <b>{point.y:.f}</b><br/><b>{point.percentage:.2f} %</b>',
            }
          },
          series: {
            shadow: true
          }
        },
        // plotOptions: {
          // pie: {
            // allowPointSelect: true,
            // cursor: 'pointer',
            // dataLabels: {
              // enabled: true,
              // color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'gray',
              // formatter: function () {
                // //return this.y.formatMoney(decimal, ',', '.');
                // return (this.y!=0)? this.y.formatMoney(decimal, ',', '.') : null;
              // }
            // }
          // }
        // },
        series: data_.serie
      }

      return chartOptions
    },

    formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
      try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        let response = negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");

        return response.replace('.00', '')
      } catch (e) {
        console.log(e)
      }
    }
  }
}

export default mixinCharts
